import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {useSelector} from "react-redux";
import {getUrl} from "../../../constants/urls";
import {getCurrentCustomer} from "../../../redux/Selectors/customers.selectors";

export const useContactListurl = () => {
  const currentCustomer = useSelector(getCurrentCustomer);
  return currentCustomer ? getUrl("getContacts")(currentCustomer.id) : null;
};

export const LIST_HEADERS = ["first_name", "last_name", "email", "phone", "is_primary"];

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_customercontactperson"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_customercontactperson"]},
];

export const PERMS_FOR_ACTIONS = [
  "change_customercontactperson",
  "delete_customercontactperson",
];
